module.exports = __webpack_public_path__ + "static/dashboard-a19c743b3c4e4f184d6a0e85db3265c9.png";